// Model.js
// -----------------------
// @module Case
define("BTM.SEOFix.SEOFix.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/SEOFix/SuiteScript2/SEOFix.Service.ss"
            ),
            true
        )
});
});
